// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-tLic","col":"styles_col__3N2vM"};